// extracted by mini-css-extract-plugin
module.exports = {"shade":"_1hgQxpID6N8Bs91gv6VqPc","active":"kByLXR8PZLSoxIosrR9R-","tick":"ZT3M2iEWJts8p2kZSvt9d"};